import * as TYPES from './actions/types';

export const LOCAL_STORAGE_KEY = 'user:localization';

export const initialState = {
  patientIdentifierLabel: '',
  copyrightStatement: '',
};

export const localizationReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case TYPES.LOCALIZED_PT_IDENTIFIER_LOADED_SUCCESS:
      newState = { ...state, patientIdentifierLabel: action.patientIdentifierLabel };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default localizationReducer;
